export default "__VITE_PUBLIC_ASSET__08f3d06c__"